import Controller, { inject as controller } from '@ember/controller';
import { computed } from '@ember/object';
import { IdentityProvider } from 'cio/models/sso-configuration';

import LoginController from 'cio/pods/login/controller';

export default class SsoController extends Controller {
  @controller('login') loginController!: LoginController;

  // for usage in the template :
  IdentityProvider = IdentityProvider;
  loginOktaLogoImage = new URL('cio/assets/images/login-okta-logo.svg', import.meta.url).toString();
  loginAzureLogoImage = new URL('cio/assets/images/login-azure-logo.svg', import.meta.url).toString();

  @computed('loginController.email', 'loginController.ssoConfigurationForLogin.oidcGoogleHostedDomain')
  get hasGoogleSSOEmailDomainMismatch() {
    let {
      email,
      ssoConfigurationForLogin: { oidcGoogleHostedDomain },
      userExternalIdentityEmail,
    } = this.loginController;

    // user has external identity, logged-in using SSO before
    // no need to check if Customer.io/Google e-mail domains match:
    if (userExternalIdentityEmail) {
      return false;
    }

    let [, emailDomain] = email.split('@');
    return oidcGoogleHostedDomain && emailDomain !== oidcGoogleHostedDomain;
  }
}
